import { AbstractControl, FormControl } from '@angular/forms';

export const setValue = (control: FormControl | AbstractControl, value: boolean | null): void => {
  control.setValue(value);
  control.markAsTouched();
  control.markAsDirty();
};
